import Button from "../Components/Button"
import { useAtom } from "jotai"
import { redirectAtom, userAtom } from "../state"
import api from "../services/api"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import Spinner from "../Components/Spinner"

const Register = () => {
  const [redirect] = useAtom(redirectAtom)
  const navigate = useNavigate()
  const { org } = useParams()
  const [organization, setOrganization] = useState(null)
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setLoading(true)
    if (org) {
      api.getOrganizationBySlug(org)
        .then(response => {
          if (!response.data) {
            // Organization not found, redirect to register without org param
            console.error('Organization not found:', org)
            navigate('/register', { replace: true })
          } else {
            setOrganization(response.data)
          }
        })
        .catch(error => {
          console.error('Failed to load organization:', error)
          navigate('/register', { replace: true })
        })
        .finally(() => setLoading(false))
    } else {
      setTimeout(() => setLoading(false), 1000)
    }
  }, [org, navigate])

  if (loading) {
    return <div className="flex items-center justify-center h-screen bg-background"><Spinner /></div>
  }

  return (
    <div className="flex min-h-screen flex-col justify-between bg-background">
      <div className="mx-auto max-w-5xl p-12">
        <img className="mb-16 w-[300px]" src="/logo.png" />
        <div className="flex flex-col gap-8 md:flex-row md:gap-16">
          <div className="flex-1 text-center flex flex-col">
            <div className="rounded-xl border border-neutral-500 px-4 py-12 flex flex-col items-center flex-1">
              <h1 className="mb-8 text-xl font-bold text-black">Login</h1>
              <div className="mb-6 text-lg font-bold">Already have an Encircled account?</div>
              <div className="flex-grow"></div>
              <Button onClick={() => navigate("/login")}>Login</Button>
            </div>
          </div>

          <div className="flex-1 text-center">
            <div className="rounded-xl border border-neutral-500 px-4 py-12">
              {redirect ? (
                <div className="mb-8 flex items-center gap-4 rounded bg-neutral-50 p-6">
                  <i className="fas fa-info-circle"></i>
                  {redirect.includes("plan") ? (
                    <div>To view the student's mentor circle please create an account or login</div>
                  ) : (
                    <div>To get access, please create an account or login</div>
                  )}
                </div>
              ) : null}
              <h1 className="mb-8 text-xl font-bold text-black">Sign Up</h1>
              {organization ? <div className="mb-8">Welcome {organization.name}!</div> : null}
              <div className="mb-6 text-lg">
                Create your Encircled account to manage your Mentor Circle, access resources and
                much more.
              </div>
              <Button className={"mx-auto"} onClick={() => navigate("/register/new")}>Get Started</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Register
